import adminApiFetch from './apiService';

const returnOrderService = {
  // 獲取退貨單列表（用於表格）
  getRecords: async (params = {}) => {
    const res = await adminApiFetch('return_orders/get_records', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取所有退貨單 ID（用於篩選）
  getIds: async (params = {}) => {
    const res = await adminApiFetch('return_orders/get_ids', {
      method: 'POST',
      body: params
    });
    return res.json();
  },

  // 獲取單個退貨單
  get: async (id) => {
    const res = await adminApiFetch(`return_orders/${id}`, {
      method: 'GET'
    });
    return res.json();
  },

  // 獲取單個退貨單（別名）
  getById: async (id) => {
    return returnOrderService.get(id);
  },

  // 創建退貨單
  create: async (data) => {
    const res = await adminApiFetch('return_orders', {
      method: 'POST',
      body: { return_order: data }
    });
    return res.json();
  },

  // 更新退貨單
  update: async (id, data) => {
    const res = await adminApiFetch(`return_orders/${id}`, {
      method: 'PUT',
      body: { return_order: data }
    });
    return res.json();
  },

  // 刪除退貨單
  delete: async (id) => {
    const res = await adminApiFetch(`return_orders/${id}`, {
      method: 'DELETE'
    });
    return res.json();
  },

  // 驗證退貨
  verify: async (id) => {
    const res = await adminApiFetch(`return_orders/${id}/verify`, {
      method: 'POST'
    });
    return res.json();
  },

  // 完成入庫
  store: async (id) => {
    const res = await adminApiFetch(`return_orders/${id}/store`, {
      method: 'POST'
    });
    return res.json();
  },

  // 取消退貨單
  cancel: async (id) => {
    const res = await adminApiFetch(`return_orders/${id}/cancel`, {
      method: 'POST'
    });
    return res.json();
  },

  // 恢復退貨單
  resume: async (id) => {
    const res = await adminApiFetch(`return_orders/${id}/resume`, {
      method: 'POST'
    });
    return res.json();
  },

  // 匯出
  export: async (ids) => {
    const res = await adminApiFetch('return_orders/export', {
      method: 'POST',
      body: { ids }
    });
    return res.json();
  },

  // 獲取訂單選項（用於 Select - 游標分頁）
  getOrders: async ({ search = '', sinceId = null, pageSize = 20 } = {}) => {
    const params = new URLSearchParams({
      page_size: pageSize,
      direction: 'desc'
    });

    if (search) {
      params.append('search', search);
    }

    if (sinceId) {
      params.append('since_id', sinceId);
    }

    const res = await adminApiFetch(`orders?${params.toString()}`, {
      method: 'GET'
    });
    const response = await res.json();

    if (response.success && response.data) {
      return {
        options: response.data.map(order => ({
          label: order.name || `Order #${order.id}`,
          value: order.id
        })),
        hasMore: response.has_more,
        sinceId: response.since_id
      };
    }

    return { options: [], hasMore: false, sinceId: null };
  },

  // 獲取狀態選項
  getStatuses: async () => {
    return ['pending', 'verified', 'stored', 'canceled'];
  },

  // 獲取驗收影片
  getVideos: async (id) => {
    const response = await adminApiFetch(`return_orders/${id}/videos`, { method: 'GET' });
    return response.json();
  },

  // 獲取商品選項（用於 Select - 游標分頁）
  getProducts: async ({ search = '', sinceId = null, pageSize = 20 } = {}) => {
    const params = new URLSearchParams({
      limit: pageSize // Admin products index uses limit
    });

    if (search) {
      params.append('search', search);
    }

    const res = await adminApiFetch(`products?${params.toString()}`, {
      method: 'GET'
    });
    const response = await res.json();

    if (response.success && response.data) {
      return {
        options: response.data.map(product => ({
          label: `${product.sku} - ${product.name}`,
          value: product.id,
          sku: product.sku,
          name: product.name,
          validity_days: product.validity_days || 0,
          manufacturing_date_required: product.manufacturing_date_required
        })),
        hasMore: false, // Admin products index (simple search) doesn't return has_more usually, unless using cursor logic which index doesn't seem to fully support yet (it uses simple limit)
        sinceId: null
      };
    }

    return { options: [], hasMore: false, sinceId: null };
  },

  // 匯入退貨單
  import: async (formData) => {
    const response = await adminApiFetch('return_orders/import', {
      method: 'POST',
      body: formData
    });
    return response.json();
  },

  // 下載匯入模板
  downloadImportTemplate: async (locale) => {
    return adminApiFetch('import_templates/download', {
      method: 'POST',
      body: JSON.stringify({ type: 'return_order', locale }),
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    });
  }
};

export { returnOrderService };
export default returnOrderService;
